<template>
  <ul class="menu-nav">
    <li
      v-for="item in MenuList"
      :key="item.id"
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item"
    >
      <a
        :href="'#' + item.url"
        v-if="item.childs.length == 0"
        class="menu-link"
      >
        <!-- <b-icon :icon="item.icon"></b-icon> -->
        <span class="menu-text">{{ item.title }}</span>
      </a>

      <a href="#" class="menu-link menu-toggle" v-if="item.childs.length > 0">
        <!-- <b-icon :icon="item.icon"></b-icon> -->
        <span class="menu-text">{{ item.title }}</span>
        <i class="menu-arrow"></i>
      </a>
      <div class="menu-submenu" v-if="item.childs.length > 0">
        <span class="menu-arrow"></span>
        <ul class="menu-subnav">
          <li aria-haspopup="true" class="menu-item menu-item-parent">
            <span class="menu-link">
              <span class="menu-text">{{ item.title }}</span>
            </span>
          </li>
          <li
            v-for="sitem in item.childs"
            :key="sitem.id"
            aria-haspopup="true"
            data-menu-toggle="hover"
            class="menu-item"
          >
            <a :href="'#' + sitem.url" class="menu-link">
              <b-icon :icon="sitem.icon"></b-icon>
              <span class="menu-text">{{ sitem.title }}</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <!-- <router-link
      v-for="item in MenuList"
      :key="item.id"
      :to="item.url"
      v-if="item.childs.length == 0"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      
    </router-link> -->
  </ul>
</template>

<script>
import httpHelper from "../../../helpers/httpHelper";
export default {
  name: "KTMenu",
  data() {
    return {
      MenuList: [],
    };
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
    menuChilds(list, parent) {
      var menus = [];
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element.parent == parent) {
          menus.push({
            icon: element.icon,
            parent: element.parent,
            row_order: element.row_order,
            title: element.title,
            url: element.url,
            childs: this.menuChilds(list, element.id),
          });
        }
      }
      return menus.sort((a, b) => (a.row_order > b.row_order ? 1 : -1));
    },
  },
  mounted() {
    httpHelper.setAuth();
    httpHelper.getData("menu").then((res) => {
      this.MenuList = this.menuChilds(res.result, null);
      //this.MenuList = res.result.sort((a, b) => (a.row_order > b.row_order) ? 1 : -1);
    });
  },
};
</script>
